import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogicielCaisseSetupService, LcSetupCheckItem, LcSetupOverview, LcSetupTreeNode } from 'app/services/logiciel-caisse/logiciel-caisse-setup.service';

@Component({
  selector: 'app-logiciel-caisse-setup-dashboard',
  templateUrl: './logiciel-caisse-setup-dashboard.component.html',
  styleUrls: ['./logiciel-caisse-setup-dashboard.component.scss'],
})
export class LogicielCaisseSetupDashboardComponent implements OnInit {
  loading = true;
  overview: LcSetupOverview | null = null;
  errorMessage = '';

  constructor(
    private readonly setupService: LogicielCaisseSetupService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    this.loading = true;
    this.errorMessage = '';
    this.setupService.loadOverview().subscribe({
      next: (overview) => {
        this.overview = overview;
        this.loading = false;
        this.refreshFeatherIcons();
      },
      error: (err: Error) => {
        this.errorMessage = err.message || 'Impossible de charger la configuration.';
        this.loading = false;
      },
    });
  }

  startWizard(): void {
    this.setupService.resetWizardContext();
    void this.router.navigate(['/main/parametre/logiciel-caisse/wizard']);
  }

  addMagasin(): void {
    this.setupService.resetWizardContext();
    void this.router.navigate(['/main/parametre/logiciel-caisse/wizard'], {
      queryParams: { mode: 'add' },
    });
  }

  openCheck(item: LcSetupCheckItem): void {
    void this.router.navigateByUrl(item.route);
  }

  nodeIcon(type: LcSetupTreeNode['type']): string {
    switch (type) {
      case 'etablissement':
        return 'briefcase';
      case 'entrepot':
        return 'home';
      case 'caisse':
        return 'monitor';
      case 'vendeur':
        return 'user';
      default:
        return 'circle';
    }
  }

  private refreshFeatherIcons(): void {
    setTimeout(() => {
      const feather = (window as unknown as { feather?: { replace: () => void } }).feather;
      feather?.replace();
    }, 0);
  }
}
